const SDK_VERSION = '8.9.1';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
